var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _g2, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _mask, _g3, _path39, _g4, _circle, _g5, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g6, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDungeonMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 125,
    viewBox: "0 0 211 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.373 121.599H115.322L116.57 119.935V47.125H137.373V121.599Z",
    fill: "url(#paint0_linear_860_19028)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4415 64.1111C28.4415 69.0227 26.9285 73.0708 23.9024 76.2553C20.7171 79.5747 16.4833 81.2344 11.201 81.2344H0.490356V80.7891C1.79103 80.7891 2.44136 79.7231 2.44136 77.5912V45.0447H2.87934C2.87934 45.8003 3.23769 46.3401 3.95439 46.6639C4.45873 46.9068 5.12234 47.0282 5.94521 47.0282H11.201C16.4833 47.0282 20.7171 48.6879 23.9024 52.0074C26.9285 55.1649 28.4415 59.1994 28.4415 64.1111ZM20.4384 64.1111C20.4384 58.1199 17.1204 55.1244 10.4843 55.1244V73.1383C17.0938 73.1383 20.4119 70.1292 20.4384 64.1111Z",
    fill: "url(#paint1_linear_860_19028)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7646 47.433C58.0213 47.433 57.4772 47.7704 57.1321 48.4451C56.8401 48.9848 56.6941 49.7135 56.6941 50.631V65.1636C56.6941 68.2131 56.4154 70.615 55.858 72.3692C55.1678 74.5281 53.8671 76.4037 51.956 77.996C49.3812 80.1549 46.5276 81.2344 43.3954 81.2344C40.2632 81.2344 37.4097 80.1549 34.8349 77.996C32.9237 76.4037 31.623 74.5281 30.9328 72.3692C30.3489 70.615 30.0569 68.2131 30.0569 65.1636V50.631C30.0569 48.499 29.3667 47.433 27.9864 47.433V46.9878H39.8517V47.433C38.5511 47.433 37.9007 48.4586 37.9007 50.5096V67.5115C37.9007 69.7784 38.7502 71.4516 40.449 72.5311C41.4311 73.1518 42.4133 73.4621 43.3954 73.4621C44.3775 73.4621 45.3464 73.1518 46.302 72.5311C48.0008 71.4516 48.8503 69.7784 48.8503 67.5115V50.5096C48.8503 48.4586 48.1999 47.433 46.8993 47.433V46.9878H58.7646V47.433Z",
    fill: "url(#paint2_linear_860_19028)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6766 81.2344H75.8113V80.7891C77.112 80.7891 77.7623 79.7231 77.7623 77.5912V76.9435L69.799 64.8802V77.6721C69.799 79.7501 70.4361 80.7891 71.7102 80.7891V81.2344H59.8847V80.7891C61.1588 80.7891 61.7959 79.7231 61.7959 77.5912V50.631C61.7959 48.499 61.1588 47.433 59.8847 47.433V46.9878H71.7102V47.433C70.4361 47.433 69.799 48.472 69.799 50.5501V51.2787L77.7623 63.342V50.631C77.7623 48.499 77.112 47.433 75.8113 47.433V46.9878H87.6766V47.433C86.3759 47.433 85.7256 48.472 85.7256 50.5501V77.6721C85.7256 79.7501 86.3759 80.7891 87.6766 80.7891V81.2344Z",
    fill: "url(#paint3_linear_860_19028)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.808 81.2344H106.283C100.974 81.2344 96.7271 79.5747 93.5418 76.2553C90.4892 73.0708 88.9629 69.0227 88.9629 64.1111C88.9629 59.1994 90.4759 55.1514 93.5019 51.9669C96.6873 48.6475 100.948 46.9878 106.283 46.9878L108.314 47.0282C110.358 47.0282 111.38 46.367 111.38 45.0447H111.818V57.7961C110.703 55.853 108.592 54.9625 105.487 55.1244C103.071 55.2323 101.041 56.1634 99.3948 57.9175C97.7756 59.6447 96.966 61.7092 96.966 64.1111C96.966 66.2161 97.6031 68.0917 98.8772 69.7379C100.151 71.3571 101.771 72.4096 103.735 72.8954V66.0137C103.735 63.8817 103.084 62.8157 101.784 62.8157V62.3704H113.808V62.8157C112.481 62.8157 111.818 63.8412 111.818 65.8922V77.5912C111.818 78.5357 111.937 79.2779 112.176 79.8176C112.441 80.3304 112.8 80.6272 113.251 80.7082L113.45 80.7487C113.53 80.7756 113.649 80.7891 113.808 80.7891V81.2344Z",
    fill: "url(#paint4_linear_860_19028)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M137.288 121.599H114.513V121.154C115.814 121.154 116.464 120.088 116.464 117.956V50.631C116.464 48.499 115.814 47.433 114.513 47.433V46.9878H137.288V57.0674H136.85C136.85 55.7451 135.801 55.0839 133.704 55.0839H124.427V79.2065H133.413C135.483 79.2065 136.519 78.5453 136.519 77.2229H136.957V89.2862H136.519C136.519 87.9638 135.51 87.3026 133.493 87.3026H124.427V113.503H133.704C135.801 113.503 136.85 112.842 136.85 111.519H137.288V121.599Z",
    fill: "url(#paint5_linear_860_19028)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.456 64.1111C170.456 68.51 169.102 72.4636 166.395 75.9719C164.298 78.6706 161.365 80.3439 157.595 80.9915C155.923 81.2884 155.087 81.9631 155.087 83.0156H154.131C154.131 81.9631 153.295 81.2884 151.623 80.9915C147.854 80.3439 144.92 78.6706 142.823 75.9719C140.116 72.4636 138.762 68.51 138.762 64.1111C138.762 59.7122 140.116 55.7586 142.823 52.2502C144.92 49.5515 147.854 47.8783 151.623 47.2306C153.295 46.9338 154.131 46.2591 154.131 45.2066H155.087C155.087 46.2591 155.923 46.9338 157.595 47.2306C161.365 47.8783 164.298 49.5515 166.395 52.2502C169.102 55.7586 170.456 59.7122 170.456 64.1111ZM162.174 64.1111C162.174 62.0331 161.537 60.1845 160.263 58.5652C159.281 57.2968 157.914 56.5007 156.162 56.1769C155.87 56.1229 155.405 56.0959 154.768 56.0959C154.131 56.0959 153.653 56.1229 153.335 56.1769C151.583 56.5007 150.216 57.2968 149.234 58.5652C147.96 60.1845 147.323 62.0331 147.323 64.1111C147.323 66.1891 147.96 68.0377 149.234 69.6569C150.216 70.9253 151.583 71.7215 153.335 72.0453C153.653 72.0993 154.131 72.1263 154.768 72.1263C155.405 72.1263 155.87 72.0993 156.162 72.0453C157.914 71.7215 159.281 70.9253 160.263 69.6569C161.537 68.0377 162.174 66.1891 162.174 64.1111Z",
    fill: "url(#paint6_linear_860_19028)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M198.533 81.2344H186.668V80.7891C187.968 80.7891 188.619 79.7231 188.619 77.5912V76.9435L180.655 64.8802V77.6721C180.655 79.7501 181.292 80.7891 182.566 80.7891V81.2344H170.741V80.7891C172.015 80.7891 172.652 79.7231 172.652 77.5912V50.631C172.652 48.499 172.015 47.433 170.741 47.433V46.9878H182.566V47.433C181.292 47.433 180.655 48.472 180.655 50.5501V51.2787L188.619 63.342V50.631C188.619 48.499 187.968 47.433 186.668 47.433V46.9878H198.533V47.433C197.232 47.433 196.582 48.472 196.582 50.5501V77.6721C196.582 79.7501 197.232 80.7891 198.533 80.7891V81.2344Z",
    fill: "url(#paint7_linear_860_19028)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_860_19028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4415 67.4396C28.4415 72.3512 26.9285 76.3993 23.9025 79.5838C20.7171 82.9032 16.4833 84.5629 11.201 84.5629H0.490382L0.490356 81.1539C1.79103 81.1539 2.44136 81.7158 2.44136 79.5838L2.44139 48.3732H2.87937C2.87937 49.1288 3.23772 49.6685 3.95442 49.9924C4.45876 50.2353 5.12237 50.3567 5.94524 50.3567H11.201C16.4833 50.3567 20.7171 52.0164 23.9025 55.3358C26.9285 58.4933 28.4415 62.5279 28.4415 67.4396ZM20.4384 67.4396C20.4384 61.4484 17.1204 58.4529 10.4843 58.4529V76.4668C17.0939 76.4668 20.4119 73.4577 20.4384 67.4396Z",
    fill: "url(#paint8_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7646 50.7615C58.0214 50.7615 57.4772 51.0989 57.1321 51.7735C56.8401 52.3133 56.6941 53.0419 56.6941 53.9595V68.4921C56.6941 71.5416 56.4154 73.9435 55.858 75.6976C55.1678 77.8566 53.8672 79.7322 51.956 81.3245C49.3812 83.4834 46.5277 84.5629 43.3954 84.5629C40.2632 84.5629 37.4097 83.4834 34.8349 81.3245C32.9237 79.7322 31.623 77.8566 30.9329 75.6976C30.3489 73.9435 30.0569 71.5416 30.0569 68.4921V53.9595C30.0569 51.8275 29.3668 50.7615 27.9865 50.7615V47.125H39.8518V50.7615C38.5511 50.7615 37.9008 51.787 37.9008 53.8381V70.84C37.9008 73.1069 38.7502 74.7801 40.449 75.8596C41.4312 76.4803 42.4133 76.7906 43.3954 76.7906C44.3776 76.7906 45.3464 76.4803 46.302 75.8596C48.0009 74.7801 48.8503 73.1069 48.8503 70.84V53.8381C48.8503 51.787 48.2 50.7615 46.8993 50.7615V47.125H58.7646V50.7615Z",
    fill: "url(#paint9_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6766 84.5629H75.8113L75.8113 81.2416C77.112 81.2416 77.4606 81.2213 77.7623 80.9197V80.272L69.799 68.2087V81.0006C69.799 81.0006 70.4361 80.9197 71.7102 80.9197L71.7102 84.5629H59.8847L59.8847 81.0006C61.1588 81.0006 61.7959 81.2416 61.7959 80.9197V53.9595C61.7959 51.8275 61.1589 50.7615 59.8847 50.7615V47.125H71.7102V50.7615C70.4361 50.7615 69.799 51.8005 69.799 53.8785V54.6072L77.7623 66.6704V53.9595C77.7623 51.8275 77.112 50.7615 75.8113 50.7615V47.125H87.6766V50.7615C86.376 50.7615 85.7256 51.8005 85.7256 53.8785V81.0006C85.9666 81.2416 86.3759 81.0006 87.6766 81.0006L87.6766 84.5629Z",
    fill: "url(#paint10_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.808 84.5629H106.283C100.974 84.5629 96.7271 82.9032 93.5418 79.5838C90.4892 76.3993 88.9629 72.3512 88.9629 67.4396C88.9629 62.5279 90.4759 58.4798 93.502 55.2954C96.6873 51.9759 100.948 50.3162 106.283 50.3162L108.314 50.3567C110.358 50.3567 111.38 49.6955 111.38 48.3732H111.818V61.1246C110.703 59.1815 108.592 58.2909 105.487 58.4529C103.071 58.5608 101.041 59.4919 99.3948 61.246C97.7756 62.9732 96.966 65.0377 96.966 67.4396C96.966 69.5446 97.6031 71.4202 98.8772 73.0664C100.151 74.6856 101.771 75.7381 103.735 76.2239V69.3422C103.735 67.2102 103.084 66.1442 101.784 66.1442V62.5191H113.808V66.1442C112.481 66.1442 111.818 67.1697 111.818 69.2207V80.9197C111.818 81.8642 111.754 80.6141 111.993 81.1539C111.993 80.8255 112.8 81.1606 113.251 81.2416H113.45C113.53 81.2686 113.649 81.1539 113.808 81.1539L113.808 84.5629Z",
    fill: "url(#paint11_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.288 124.927H114.513V121.082C115.814 121.082 116.464 121.651 116.464 119.519V53.9595C116.464 51.8275 115.814 50.7615 114.513 50.7615V47.125H137.288V60.3959H136.85C136.85 59.0736 135.801 58.4124 133.704 58.4124H124.427V82.535H133.413C135.483 82.535 136.519 81.8738 136.519 80.5514H136.957V92.6147H136.519C136.519 91.2923 135.51 90.6311 133.493 90.6311H124.427V116.831H133.704C135.801 116.831 136.85 116.17 136.85 114.848H137.288V124.927Z",
    fill: "url(#paint12_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.456 67.4396C170.456 71.8385 169.102 75.7921 166.395 79.3004C164.298 81.9991 161.365 83.6723 157.595 84.32C155.923 84.6169 155.087 85.2916 155.087 86.3441H154.131C154.131 85.2916 153.295 84.6169 151.623 84.32C147.854 83.6723 144.92 81.9991 142.823 79.3004C140.116 75.7921 138.762 71.8385 138.762 67.4396C138.762 63.0407 140.116 59.0871 142.823 55.5787C144.92 52.88 147.854 51.2068 151.623 50.5591C153.295 50.2623 154.131 49.5876 154.131 48.5351H155.087C155.087 49.5876 155.923 50.2623 157.595 50.5591C161.365 51.2068 164.298 52.88 166.395 55.5787C169.102 59.0871 170.456 63.0407 170.456 67.4396ZM162.174 67.4396C162.174 65.3616 161.537 63.5129 160.263 61.8937C159.281 60.6253 157.914 59.8292 156.162 59.5054C155.87 59.4514 155.405 59.4244 154.768 59.4244C154.131 59.4244 153.653 59.4514 153.335 59.5054C151.583 59.8292 150.216 60.6253 149.234 61.8937C147.96 63.5129 147.323 65.3616 147.323 67.4396C147.323 69.5176 147.96 71.3662 149.234 72.9854C150.216 74.2538 151.583 75.0499 153.335 75.3738C153.653 75.4278 154.131 75.4548 154.768 75.4548C155.405 75.4548 155.87 75.4278 156.162 75.3738C157.914 75.0499 159.281 74.2538 160.263 72.9854C161.537 71.3662 162.174 69.5176 162.174 67.4396Z",
    fill: "url(#paint13_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.533 84.5629H186.668L186.668 81.1175C187.968 81.1175 188.713 80.8255 188.619 80.9197V80.272L180.655 68.2087V81.0006C180.896 81.2416 181.292 81.1175 182.566 81.1175L182.566 84.5629H170.741L170.741 81.1175C172.015 81.1175 172.652 81.6576 172.652 79.5256V53.9595C172.652 51.8275 172.015 50.7615 170.741 50.7615V47.125H182.566V50.7615C181.292 50.7615 180.655 51.8005 180.655 53.8785V54.6072L188.619 66.6704V53.9595C188.619 51.8275 187.968 50.7615 186.668 50.7615V47.125H198.533V50.7615C197.232 50.7615 196.582 51.8005 196.582 53.8785V79.1613C196.582 81.2393 197.232 81.1175 198.533 81.1175L198.533 84.5629Z",
    fill: "url(#paint14_linear_860_19028)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.657 84.5699V81.2414H104.504C102.424 81.2414 100.76 80.4093 97.0153 79.1611C97.4313 82.4896 99.0955 84.5699 105.336 84.5699H113.657Z",
    fill: "url(#paint15_linear_860_19028)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M134.876 90.8107H124.475L123.227 86.6501L136.957 87.0662V92.4749H136.124C136.124 91.4764 135.292 90.9494 134.876 90.8107Z",
    fill: "#FFB032"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M134.46 58.3586H124.475L123.227 54.198L136.957 54.6141L137.373 60.4388H136.957C136.957 59.4403 135.708 58.3586 134.46 58.3586Z",
    fill: "#FFB032"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4415 64.1111C28.4415 69.0227 26.9285 73.0708 23.9024 76.2553C20.7171 79.5747 16.4833 81.2344 11.201 81.2344H0.490356V80.7891C1.79103 80.7891 2.44136 79.7231 2.44136 77.5912V45.0447H2.87934C2.87934 45.8003 3.23769 46.3401 3.95439 46.6639C4.45873 46.9068 5.12234 47.0282 5.94521 47.0282H11.201C16.4833 47.0282 20.7171 48.6879 23.9024 52.0074C26.9285 55.1649 28.4415 59.1994 28.4415 64.1111ZM20.4384 64.1111C20.4384 58.1199 17.1204 55.1244 10.4843 55.1244V73.1383C17.0938 73.1383 20.4119 70.1292 20.4384 64.1111Z",
    fill: "url(#paint16_linear_860_19028)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4415 64.1111C28.4415 69.0227 26.9285 73.0708 23.9024 76.2553C20.7171 79.5747 16.4833 81.2344 11.201 81.2344H0.490356V80.7891C1.79103 80.7891 2.44136 79.7231 2.44136 77.5912V45.0447H2.87934C2.87934 45.8003 3.23769 46.3401 3.95439 46.6639C4.45873 46.9068 5.12234 47.0282 5.94521 47.0282H11.201C16.4833 47.0282 20.7171 48.6879 23.9024 52.0074C26.9285 55.1649 28.4415 59.1994 28.4415 64.1111ZM20.4384 64.1111C20.4384 58.1199 17.1204 55.1244 10.4843 55.1244V73.1383C17.0938 73.1383 20.4119 70.1292 20.4384 64.1111Z",
    fill: "url(#paint17_linear_860_19028)",
    fillOpacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7646 47.433C58.0213 47.433 57.4772 47.7704 57.1321 48.4451C56.8401 48.9848 56.6941 49.7135 56.6941 50.631V65.1636C56.6941 68.2131 56.4154 70.615 55.858 72.3692C55.1678 74.5281 53.8671 76.4037 51.956 77.996C49.3812 80.1549 46.5276 81.2344 43.3954 81.2344C40.2632 81.2344 37.4097 80.1549 34.8349 77.996C32.9237 76.4037 31.623 74.5281 30.9328 72.3692C30.3489 70.615 30.0569 68.2131 30.0569 65.1636V50.631C30.0569 48.499 29.3667 47.433 27.9864 47.433V46.9878H39.8517V47.433C38.5511 47.433 37.9007 48.4586 37.9007 50.5096V67.5115C37.9007 69.7784 38.7502 71.4516 40.449 72.5311C41.4311 73.1518 42.4133 73.4621 43.3954 73.4621C44.3775 73.4621 45.3464 73.1518 46.302 72.5311C48.0008 71.4516 48.8503 69.7784 48.8503 67.5115V50.5096C48.8503 48.4586 48.1999 47.433 46.8993 47.433V46.9878H58.7646V47.433Z",
    fill: "url(#paint18_linear_860_19028)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7646 47.433C58.0213 47.433 57.4772 47.7704 57.1321 48.4451C56.8401 48.9848 56.6941 49.7135 56.6941 50.631V65.1636C56.6941 68.2131 56.4154 70.615 55.858 72.3692C55.1678 74.5281 53.8671 76.4037 51.956 77.996C49.3812 80.1549 46.5276 81.2344 43.3954 81.2344C40.2632 81.2344 37.4097 80.1549 34.8349 77.996C32.9237 76.4037 31.623 74.5281 30.9328 72.3692C30.3489 70.615 30.0569 68.2131 30.0569 65.1636V50.631C30.0569 48.499 29.3667 47.433 27.9864 47.433V46.9878H39.8517V47.433C38.5511 47.433 37.9007 48.4586 37.9007 50.5096V67.5115C37.9007 69.7784 38.7502 71.4516 40.449 72.5311C41.4311 73.1518 42.4133 73.4621 43.3954 73.4621C44.3775 73.4621 45.3464 73.1518 46.302 72.5311C48.0008 71.4516 48.8503 69.7784 48.8503 67.5115V50.5096C48.8503 48.4586 48.1999 47.433 46.8993 47.433V46.9878H58.7646V47.433Z",
    fill: "url(#paint19_linear_860_19028)",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6766 81.2344H75.8113V80.7891C77.112 80.7891 77.7623 79.7231 77.7623 77.5912V76.9435L69.799 64.8802V77.6721C69.799 79.7501 70.4361 80.7891 71.7102 80.7891V81.2344H59.8847V80.7891C61.1588 80.7891 61.7959 79.7231 61.7959 77.5912V50.631C61.7959 48.499 61.1588 47.433 59.8847 47.433V46.9878H71.7102V47.433C70.4361 47.433 69.799 48.472 69.799 50.5501V51.2787L77.7623 63.342V50.631C77.7623 48.499 77.112 47.433 75.8113 47.433V46.9878H87.6766V47.433C86.3759 47.433 85.7256 48.472 85.7256 50.5501V77.6721C85.7256 79.7501 86.3759 80.7891 87.6766 80.7891V81.2344Z",
    fill: "url(#paint20_linear_860_19028)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6766 81.2344H75.8113V80.7891C77.112 80.7891 77.7623 79.7231 77.7623 77.5912V76.9435L69.799 64.8802V77.6721C69.799 79.7501 70.4361 80.7891 71.7102 80.7891V81.2344H59.8847V80.7891C61.1588 80.7891 61.7959 79.7231 61.7959 77.5912V50.631C61.7959 48.499 61.1588 47.433 59.8847 47.433V46.9878H71.7102V47.433C70.4361 47.433 69.799 48.472 69.799 50.5501V51.2787L77.7623 63.342V50.631C77.7623 48.499 77.112 47.433 75.8113 47.433V46.9878H87.6766V47.433C86.3759 47.433 85.7256 48.472 85.7256 50.5501V77.6721C85.7256 79.7501 86.3759 80.7891 87.6766 80.7891V81.2344Z",
    fill: "url(#paint21_linear_860_19028)",
    fillOpacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M113.808 81.2344H106.283C100.974 81.2344 96.7271 79.5747 93.5418 76.2553C90.4892 73.0708 88.9629 69.0227 88.9629 64.1111C88.9629 59.1994 90.4759 55.1514 93.5019 51.9669C96.6873 48.6475 100.948 46.9878 106.283 46.9878L108.314 47.0282C110.358 47.0282 111.38 46.367 111.38 45.0447H111.818V57.7961C110.703 55.853 108.592 54.9625 105.487 55.1244C103.071 55.2323 101.041 56.1634 99.3948 57.9175C97.7756 59.6447 96.966 61.7092 96.966 64.1111C96.966 66.2161 97.603 68.0917 98.8772 69.7379C100.151 71.3571 101.771 72.4096 103.735 72.8954V66.0137C103.735 63.8817 103.084 62.8157 101.784 62.8157V62.3704H113.808V62.8157C112.481 62.8157 111.818 63.8412 111.818 65.8922V77.5912C111.818 78.5357 111.937 79.2779 112.176 79.8176C112.441 80.3304 112.8 80.6272 113.251 80.7082L113.45 80.7487C113.53 80.7756 113.649 80.7891 113.808 80.7891V81.2344Z",
    fill: "url(#paint22_linear_860_19028)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.808 81.2344H106.283C100.974 81.2344 96.7271 79.5747 93.5418 76.2553C90.4892 73.0708 88.9629 69.0227 88.9629 64.1111C88.9629 59.1994 90.4759 55.1514 93.5019 51.9669C96.6873 48.6475 100.948 46.9878 106.283 46.9878L108.314 47.0282C110.358 47.0282 111.38 46.367 111.38 45.0447H111.818V57.7961C110.703 55.853 108.592 54.9625 105.487 55.1244C103.071 55.2323 101.041 56.1634 99.3948 57.9175C97.7756 59.6447 96.966 61.7092 96.966 64.1111C96.966 66.2161 97.603 68.0917 98.8772 69.7379C100.151 71.3571 101.771 72.4096 103.735 72.8954V66.0137C103.735 63.8817 103.084 62.8157 101.784 62.8157V62.3704H113.808V62.8157C112.481 62.8157 111.818 63.8412 111.818 65.8922V77.5912C111.818 78.5357 111.937 79.2779 112.176 79.8176C112.441 80.3304 112.8 80.6272 113.251 80.7082L113.45 80.7487C113.53 80.7756 113.649 80.7891 113.808 80.7891V81.2344Z",
    fill: "url(#paint23_linear_860_19028)",
    fillOpacity: 0.2
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M137.288 121.599H114.513V121.154C115.814 121.154 116.464 120.088 116.464 117.956V50.631C116.464 48.499 115.814 47.433 114.513 47.433V46.9878H137.288V57.0674H136.85C136.85 55.7451 135.801 55.0839 133.704 55.0839H124.427V79.2065H133.413C135.483 79.2065 136.519 78.5453 136.519 77.2229H136.957V89.2862H136.519C136.519 87.9638 135.51 87.3026 133.493 87.3026H124.427V113.503H133.704C135.801 113.503 136.85 112.842 136.85 111.519H137.288V121.599Z",
    fill: "url(#paint24_linear_860_19028)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M137.288 121.599H114.513V121.154C115.814 121.154 116.464 120.088 116.464 117.956V50.631C116.464 48.499 115.814 47.433 114.513 47.433V46.9878H137.288V57.0674H136.85C136.85 55.7451 135.801 55.0839 133.704 55.0839H124.427V79.2065H133.413C135.483 79.2065 136.519 78.5453 136.519 77.2229H136.957V89.2862H136.519C136.519 87.9638 135.51 87.3026 133.493 87.3026H124.427V113.503H133.704C135.801 113.503 136.85 112.842 136.85 111.519H137.288V121.599Z",
    fill: "url(#paint25_linear_860_19028)",
    fillOpacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M170.456 64.1111C170.456 68.51 169.102 72.4636 166.395 75.9719C164.298 78.6706 161.365 80.3439 157.595 80.9915C155.923 81.2884 155.087 81.9631 155.087 83.0156H154.131C154.131 81.9631 153.295 81.2884 151.623 80.9915C147.854 80.3439 144.92 78.6706 142.823 75.9719C140.116 72.4636 138.762 68.51 138.762 64.1111C138.762 59.7122 140.116 55.7586 142.823 52.2502C144.92 49.5515 147.854 47.8783 151.623 47.2306C153.295 46.9338 154.131 46.2591 154.131 45.2066H155.087C155.087 46.2591 155.923 46.9338 157.595 47.2306C161.365 47.8783 164.298 49.5515 166.395 52.2502C169.102 55.7586 170.456 59.7122 170.456 64.1111ZM162.174 64.1111C162.174 62.0331 161.537 60.1845 160.263 58.5652C159.281 57.2968 157.914 56.5007 156.162 56.1769C155.87 56.1229 155.405 56.0959 154.768 56.0959C154.131 56.0959 153.653 56.1229 153.335 56.1769C151.583 56.5007 150.216 57.2968 149.234 58.5652C147.96 60.1845 147.323 62.0331 147.323 64.1111C147.323 66.1891 147.96 68.0377 149.234 69.6569C150.216 70.9253 151.583 71.7215 153.335 72.0453C153.653 72.0993 154.131 72.1263 154.768 72.1263C155.405 72.1263 155.87 72.0993 156.162 72.0453C157.914 71.7215 159.281 70.9253 160.263 69.6569C161.537 68.0377 162.174 66.1891 162.174 64.1111Z",
    fill: "url(#paint26_linear_860_19028)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M170.456 64.1111C170.456 68.51 169.102 72.4636 166.395 75.9719C164.298 78.6706 161.365 80.3439 157.595 80.9915C155.923 81.2884 155.087 81.9631 155.087 83.0156H154.131C154.131 81.9631 153.295 81.2884 151.623 80.9915C147.854 80.3439 144.92 78.6706 142.823 75.9719C140.116 72.4636 138.762 68.51 138.762 64.1111C138.762 59.7122 140.116 55.7586 142.823 52.2502C144.92 49.5515 147.854 47.8783 151.623 47.2306C153.295 46.9338 154.131 46.2591 154.131 45.2066H155.087C155.087 46.2591 155.923 46.9338 157.595 47.2306C161.365 47.8783 164.298 49.5515 166.395 52.2502C169.102 55.7586 170.456 59.7122 170.456 64.1111ZM162.174 64.1111C162.174 62.0331 161.537 60.1845 160.263 58.5652C159.281 57.2968 157.914 56.5007 156.162 56.1769C155.87 56.1229 155.405 56.0959 154.768 56.0959C154.131 56.0959 153.653 56.1229 153.335 56.1769C151.583 56.5007 150.216 57.2968 149.234 58.5652C147.96 60.1845 147.323 62.0331 147.323 64.1111C147.323 66.1891 147.96 68.0377 149.234 69.6569C150.216 70.9253 151.583 71.7215 153.335 72.0453C153.653 72.0993 154.131 72.1263 154.768 72.1263C155.405 72.1263 155.87 72.0993 156.162 72.0453C157.914 71.7215 159.281 70.9253 160.263 69.6569C161.537 68.0377 162.174 66.1891 162.174 64.1111Z",
    fill: "url(#paint27_linear_860_19028)",
    fillOpacity: 0.2
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M198.533 81.2344H186.668V80.7891C187.968 80.7891 188.619 79.7231 188.619 77.5912V76.9435L180.655 64.8802V77.6721C180.655 79.7501 181.292 80.7891 182.566 80.7891V81.2344H170.741V80.7891C172.015 80.7891 172.652 79.7231 172.652 77.5912V50.631C172.652 48.499 172.015 47.433 170.741 47.433V46.9878H182.566V47.433C181.292 47.433 180.655 48.472 180.655 50.5501V51.2787L188.619 63.342V50.631C188.619 48.499 187.968 47.433 186.668 47.433V46.9878H198.533V47.433C197.232 47.433 196.582 48.472 196.582 50.5501V77.6721C196.582 79.7501 197.232 80.7891 198.533 80.7891V81.2344Z",
    fill: "url(#paint28_linear_860_19028)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M198.533 81.2344H186.668V80.7891C187.968 80.7891 188.619 79.7231 188.619 77.5912V76.9435L180.655 64.8802V77.6721C180.655 79.7501 181.292 80.7891 182.566 80.7891V81.2344H170.741V80.7891C172.015 80.7891 172.652 79.7231 172.652 77.5912V50.631C172.652 48.499 172.015 47.433 170.741 47.433V46.9878H182.566V47.433C181.292 47.433 180.655 48.472 180.655 50.5501V51.2787L188.619 63.342V50.631C188.619 48.499 187.968 47.433 186.668 47.433V46.9878H198.533V47.433C197.232 47.433 196.582 48.472 196.582 50.5501V77.6721C196.582 79.7501 197.232 80.7891 198.533 80.7891V81.2344Z",
    fill: "url(#paint29_linear_860_19028)",
    fillOpacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M111.993 78.3292V65.0154C111.993 64.738 112.099 62.9995 113.657 62.519C111.66 62.519 111.161 64.1833 111.161 65.0154V78.7452C111.3 79.3 111.827 80.4094 112.825 80.4094C112.16 80.4094 111.993 79.0226 111.993 78.3292Z",
    fill: "#FF9900"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_i_860_19028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3779 124.482H22.5668V121.241C23.8615 121.241 24.5089 121.782 24.5089 119.651V108.907L17.771 124.482H17.0576L10.3593 108.907V119.732C10.3593 121.809 10.9935 121.599 12.2618 121.599V124.482H0.490356V121.599C1.75866 121.599 2.39281 121.782 2.39281 119.651V93.8976C2.39281 91.8208 1.77187 90.7689 0.529991 90.742V87.8984H12.2618V90.7015C11.5484 90.7015 11.1917 91.0521 11.1917 91.7534C11.1917 92.2119 11.3766 92.8996 11.7466 93.8166L17.4143 106.924L23.082 93.8166C23.4519 92.9536 23.6369 92.2658 23.6369 91.7534C23.6369 91.1061 23.2934 90.7689 22.6064 90.742V87.8984H34.3779V90.7015C33.0831 90.7015 32.4358 91.7399 32.4358 93.8166V119.732C32.4358 121.809 33.0831 121.241 34.3779 121.241V124.482Z",
    fill: "url(#paint30_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8026 124.482H56.9915V121.599C57.7049 121.599 57.5067 121.599 57.5067 121.599C57.5067 121.599 57.8767 121.839 57.5067 120.922L57.0708 119.911H46.6469L46.1713 120.922C45.8014 121.839 45.6164 121.337 45.6164 121.795C46.0329 121.795 45.9731 121.655 46.6865 121.655V124.482H34.9151V121.241C36.2627 121.241 37.3856 122.972 38.284 120.841L51.4823 90.2565H52.1957L65.394 120.841C66.2924 122.972 67.4286 121.241 68.8026 121.241V124.482ZM53.5829 111.82L51.839 107.815L50.1347 111.82H53.5829Z",
    fill: "url(#paint31_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3164 114.692C90.3164 118.063 89.0481 120.666 86.5115 122.5C84.2919 124.118 81.5175 124.927 78.1882 124.927C75.4138 124.927 72.9565 124.361 70.8162 123.228C70.3406 122.959 69.9046 122.824 69.5083 122.824C68.5835 122.824 68.1343 123.404 68.1607 124.563L67.7247 124.604V111.981H68.1607V112.467C68.1607 113.492 69.2572 114.557 71.4504 115.663C73.6699 116.769 75.7837 117.322 77.7919 117.322C80.3549 117.322 81.6364 116.324 81.6364 114.328C81.6364 113.249 80.7777 112.332 79.0602 111.577C77.739 111.145 76.4047 110.714 75.0571 110.282C72.2034 109.311 70.2481 108.098 69.1912 106.641C67.9229 104.888 67.2887 102.69 67.2887 100.047C67.2887 96.6756 68.557 94.0729 71.0936 92.2389C73.3132 90.6206 76.0876 89.8115 79.4169 89.8115C82.1913 89.8115 84.6486 90.3779 86.7889 91.5106C87.2645 91.7803 87.7005 91.9152 88.0968 91.9152C88.9952 91.9152 89.4312 91.3353 89.4048 90.1756L89.8804 90.1351V102.757H89.4444V102.272C89.4444 101.247 88.3346 100.182 86.1151 99.076C83.922 97.9702 81.8214 97.4173 79.8132 97.4173C77.2502 97.4173 75.9687 98.4152 75.9687 100.411C75.9687 101.49 76.8274 102.407 78.5449 103.162C79.8661 103.594 81.2004 104.025 82.548 104.457C85.4281 105.428 87.3834 106.628 88.4139 108.057C89.6822 109.837 90.3164 112.049 90.3164 114.692Z",
    fill: "url(#paint32_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.494 100.33H114.058C114.058 99.0085 113.015 98.3477 110.927 98.3477H107.083V119.549C107.083 121.599 107.786 121.599 109.081 121.599L109.025 124.482H97.2137V121.714C98.5084 121.714 99.2962 121.714 99.1558 120.841V98.3477H95.3112C93.2238 98.3477 92.1801 99.0085 92.1801 100.33H91.7441V90.2565H114.494V100.33Z",
    fill: "url(#paint33_linear_860_19028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.08 124.898H154.309V121.657C155.022 121.657 155.263 121.599 155.679 121.599C155.679 121.599 155.181 122.269 154.785 121.379L151.654 114.016C151.019 114.043 150.306 114.056 149.513 114.056H148.8V121.379C148.8 121.599 149.447 121.657 150.742 121.657V124.898H138.931V121.657C140.226 121.657 140.873 122.015 140.873 121.257V88.7306H141.309C141.309 90.0522 142.313 90.713 144.321 90.713H149.513C152.631 90.713 155.036 90.9827 156.727 91.5221C158.946 92.2503 160.73 93.6393 162.077 95.6891C163.504 97.8468 164.218 100.072 164.218 102.364C164.218 104.684 163.504 106.922 162.077 109.08C161.179 110.456 160.096 111.521 158.827 112.276L162.672 121.257C163.168 122.015 164.733 121.657 166.08 121.657V124.898ZM155.102 103.699C155.392 102.809 155.392 101.933 155.102 101.07C154.758 99.937 154.018 99.2358 152.882 98.966C152.354 98.8582 150.993 98.8042 148.8 98.8042V105.965C150.993 105.965 152.354 105.911 152.882 105.803C154.018 105.533 154.758 104.832 155.102 103.699Z",
    fill: "url(#paint34_linear_860_19028)"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3779 121.986H22.5668V121.541C23.8615 121.541 24.5089 120.476 24.5089 118.345V106.41L17.771 121.986H17.0576L10.3593 106.41V118.426C10.3593 120.503 10.9935 121.541 12.2618 121.541V121.986H0.490356V121.541C1.75866 121.541 2.39281 120.476 2.39281 118.345V91.4011C2.39281 89.3243 1.77187 88.2725 0.529991 88.2455V87.76H12.2618V88.205C11.5484 88.205 11.1917 88.5557 11.1917 89.2569C11.1917 89.7154 11.3766 90.4032 11.7466 91.3202L17.4143 104.428L23.082 91.3202C23.4519 90.4571 23.6369 89.7693 23.6369 89.2569C23.6369 88.6096 23.2934 88.2725 22.6064 88.2455V87.76H34.3779V88.205C33.0831 88.205 32.4358 89.2434 32.4358 91.3202V118.426C32.4358 120.503 33.0831 121.541 34.3779 121.541V121.986Z",
    fill: "url(#paint35_linear_860_19028)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3779 121.986H22.5668V121.541C23.8615 121.541 24.5089 120.476 24.5089 118.345V106.41L17.771 121.986H17.0576L10.3593 106.41V118.426C10.3593 120.503 10.9935 121.541 12.2618 121.541V121.986H0.490356V121.541C1.75866 121.541 2.39281 120.476 2.39281 118.345V91.4011C2.39281 89.3243 1.77187 88.2725 0.529991 88.2455V87.76H12.2618V88.205C11.5484 88.205 11.1917 88.5557 11.1917 89.2569C11.1917 89.7154 11.3766 90.4032 11.7466 91.3202L17.4143 104.428L23.082 91.3202C23.4519 90.4571 23.6369 89.7693 23.6369 89.2569C23.6369 88.6096 23.2934 88.2725 22.6064 88.2455V87.76H34.3779V88.205C33.0831 88.205 32.4358 89.2434 32.4358 91.3202V118.426C32.4358 120.503 33.0831 121.541 34.3779 121.541V121.986Z",
    fill: "url(#paint36_linear_860_19028)",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8026 121.986H56.9915V121.541C57.7049 121.541 58.0616 121.19 58.0616 120.489C58.0616 120.031 57.8767 119.343 57.5067 118.426L57.0708 117.414H46.6469L46.1713 118.426C45.8014 119.343 45.6164 120.031 45.6164 120.489C45.6164 121.19 45.9731 121.541 46.6865 121.541V121.986H34.9151V121.541C36.2627 121.541 37.3856 120.476 38.284 118.345L51.4823 87.76H52.1957L65.394 118.345C66.2924 120.476 67.4286 121.541 68.8026 121.541V121.986ZM53.5829 109.323L51.839 105.318L50.1347 109.323H53.5829Z",
    fill: "url(#paint37_linear_860_19028)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8026 121.986H56.9915V121.541C57.7049 121.541 58.0616 121.19 58.0616 120.489C58.0616 120.031 57.8767 119.343 57.5067 118.426L57.0708 117.414H46.6469L46.1713 118.426C45.8014 119.343 45.6164 120.031 45.6164 120.489C45.6164 121.19 45.9731 121.541 46.6865 121.541V121.986H34.9151V121.541C36.2627 121.541 37.3856 120.476 38.284 118.345L51.4823 87.76H52.1957L65.394 118.345C66.2924 120.476 67.4286 121.541 68.8026 121.541V121.986ZM53.5829 109.323L51.839 105.318L50.1347 109.323H53.5829Z",
    fill: "url(#paint38_linear_860_19028)",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3164 112.196C90.3164 115.567 89.0481 118.17 86.5115 120.004C84.2919 121.622 81.5175 122.431 78.1882 122.431C75.4138 122.431 72.9565 121.865 70.8162 120.732C70.3406 120.462 69.9046 120.327 69.5083 120.327C68.5835 120.327 68.1343 120.907 68.1607 122.067L67.7247 122.107V109.485H68.1607V109.97C68.1607 110.995 69.2572 112.061 71.4503 113.167C73.6699 114.272 75.7837 114.825 77.7919 114.825C80.3549 114.825 81.6364 113.827 81.6364 111.831C81.6364 110.753 80.7777 109.836 79.0602 109.08C77.739 108.649 76.4047 108.217 75.0571 107.786C72.2034 106.815 70.2481 105.601 69.1912 104.145C67.9229 102.392 67.2887 100.194 67.2887 97.5504C67.2887 94.1791 68.557 91.5764 71.0936 89.7424C73.3132 88.1241 76.0876 87.315 79.4169 87.315C82.1913 87.315 84.6486 87.8814 86.7889 89.0142C87.2645 89.2839 87.7005 89.4187 88.0968 89.4187C88.9952 89.4187 89.4312 88.8388 89.4048 87.6791L89.8804 87.6386V100.261H89.4444V99.7755C89.4444 98.7506 88.3346 97.6853 86.1151 96.5795C83.922 95.4737 81.8214 94.9208 79.8132 94.9208C77.2502 94.9208 75.9687 95.9187 75.9687 97.9145C75.9687 98.9934 76.8274 99.9104 78.5449 100.666C79.8661 101.097 81.2004 101.529 82.548 101.96C85.4281 102.931 87.3834 104.131 88.4139 105.561C89.6822 107.341 90.3164 109.552 90.3164 112.196Z",
    fill: "url(#paint39_linear_860_19028)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3164 112.196C90.3164 115.567 89.0481 118.17 86.5115 120.004C84.2919 121.622 81.5175 122.431 78.1882 122.431C75.4138 122.431 72.9565 121.865 70.8162 120.732C70.3406 120.462 69.9046 120.327 69.5083 120.327C68.5835 120.327 68.1343 120.907 68.1607 122.067L67.7247 122.107V109.485H68.1607V109.97C68.1607 110.995 69.2572 112.061 71.4503 113.167C73.6699 114.272 75.7837 114.825 77.7919 114.825C80.3549 114.825 81.6364 113.827 81.6364 111.831C81.6364 110.753 80.7777 109.836 79.0602 109.08C77.739 108.649 76.4047 108.217 75.0571 107.786C72.2034 106.815 70.2481 105.601 69.1912 104.145C67.9229 102.392 67.2887 100.194 67.2887 97.5504C67.2887 94.1791 68.557 91.5764 71.0936 89.7424C73.3132 88.1241 76.0876 87.315 79.4169 87.315C82.1913 87.315 84.6486 87.8814 86.7889 89.0142C87.2645 89.2839 87.7005 89.4187 88.0968 89.4187C88.9952 89.4187 89.4312 88.8388 89.4048 87.6791L89.8804 87.6386V100.261H89.4444V99.7755C89.4444 98.7506 88.3346 97.6853 86.1151 96.5795C83.922 95.4737 81.8214 94.9208 79.8132 94.9208C77.2502 94.9208 75.9687 95.9187 75.9687 97.9145C75.9687 98.9934 76.8274 99.9104 78.5449 100.666C79.8661 101.097 81.2004 101.529 82.548 101.96C85.4281 102.931 87.3834 104.131 88.4139 105.561C89.6822 107.341 90.3164 109.552 90.3164 112.196Z",
    fill: "url(#paint40_linear_860_19028)",
    fillOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M114.494 97.8336H114.058C114.058 96.512 113.015 95.8513 110.927 95.8513H107.083V118.466C107.083 120.516 107.73 121.541 109.025 121.541V121.986H97.2137V121.541C98.5084 121.541 99.1558 120.476 99.1558 118.345V95.8513H95.3112C93.2238 95.8513 92.1801 96.512 92.1801 97.8336H91.7441V87.76H114.494V97.8336Z",
    fill: "url(#paint41_linear_860_19028)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.494 97.8336H114.058C114.058 96.512 113.015 95.8513 110.927 95.8513H107.083V118.466C107.083 120.516 107.73 121.541 109.025 121.541V121.986H97.2137V121.541C98.5084 121.541 99.1558 120.476 99.1558 118.345V95.8513H95.3112C93.2238 95.8513 92.1801 96.512 92.1801 97.8336H91.7441V87.76H114.494V97.8336Z",
    fill: "url(#paint42_linear_860_19028)",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M166.08 121.986H154.309V121.541C155.022 121.541 155.379 121.204 155.379 120.53C155.379 120.044 155.181 119.356 154.785 118.466L151.654 111.103C151.019 111.13 150.306 111.144 149.513 111.144H148.8V118.466C148.8 120.516 149.447 121.541 150.742 121.541V121.986H138.931V121.541C140.226 121.541 140.873 120.476 140.873 118.345V85.8181H141.309C141.309 87.1397 142.313 87.8005 144.321 87.8005H149.513C152.631 87.8005 155.036 88.0702 156.727 88.6096C158.946 89.3378 160.73 90.7268 162.077 92.7766C163.504 94.9343 164.218 97.1593 164.218 99.4519C164.218 101.771 163.504 104.01 162.077 106.168C161.179 107.543 160.096 108.608 158.827 109.364L162.672 118.345C163.597 120.476 164.733 121.541 166.08 121.541V121.986ZM155.102 100.787C155.392 99.8969 155.392 99.0203 155.102 98.1573C154.758 97.0245 154.018 96.3233 152.882 96.0535C152.354 95.9457 150.993 95.8917 148.8 95.8917V103.052C150.993 103.052 152.354 102.999 152.882 102.891C154.018 102.621 154.758 101.92 155.102 100.787Z",
    fill: "url(#paint43_linear_860_19028)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.08 121.986H154.309V121.541C155.022 121.541 155.379 121.204 155.379 120.53C155.379 120.044 155.181 119.356 154.785 118.466L151.654 111.103C151.019 111.13 150.306 111.144 149.513 111.144H148.8V118.466C148.8 120.516 149.447 121.541 150.742 121.541V121.986H138.931V121.541C140.226 121.541 140.873 120.476 140.873 118.345V85.8181H141.309C141.309 87.1397 142.313 87.8005 144.321 87.8005H149.513C152.631 87.8005 155.036 88.0702 156.727 88.6096C158.946 89.3378 160.73 90.7268 162.077 92.7766C163.504 94.9343 164.218 97.1593 164.218 99.4519C164.218 101.771 163.504 104.01 162.077 106.168C161.179 107.543 160.096 108.608 158.827 109.364L162.672 118.345C163.597 120.476 164.733 121.541 166.08 121.541V121.986ZM155.102 100.787C155.392 99.8969 155.392 99.0203 155.102 98.1573C154.758 97.0245 154.018 96.3233 152.882 96.0535C152.354 95.9457 150.993 95.8917 148.8 95.8917V103.052C150.993 103.052 152.354 102.999 152.882 102.891C154.018 102.621 154.758 101.92 155.102 100.787Z",
    fill: "url(#paint44_linear_860_19028)",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M125.694 55.7372L134.46 55.03H124.475V79.1613L125.694 79.4796V55.7372Z",
    fill: "#FFB032"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.475 87.4822H134.46L125.694 88.3215V113.461H124.475V87.4822Z",
    fill: "#FFB032"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-13-outside-1_860_19028",
    maskUnits: "userSpaceOnUse",
    x: 114.083,
    y: 81.6624,
    width: 13,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 114.083,
    y: 81.6624,
    width: 13,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.388 93.2728C123.318 93.2728 125.694 90.8976 125.694 87.9676C125.694 85.0376 123.318 82.6624 120.388 82.6624C117.458 82.6624 115.083 85.0376 115.083 87.9676C115.083 90.8976 117.458 93.2728 120.388 93.2728ZM120.388 91.8581C122.537 91.8581 124.279 90.1163 124.279 87.9676C124.279 85.819 122.537 84.0771 120.388 84.0771C118.24 84.0771 116.498 85.819 116.498 87.9676C116.498 90.1163 118.24 91.8581 120.388 91.8581Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_860_19028)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.388 93.2728C123.318 93.2728 125.694 90.8976 125.694 87.9676C125.694 85.0376 123.318 82.6624 120.388 82.6624C117.458 82.6624 115.083 85.0376 115.083 87.9676C115.083 90.8976 117.458 93.2728 120.388 93.2728ZM120.388 91.8581C122.537 91.8581 124.279 90.1163 124.279 87.9676C124.279 85.819 122.537 84.0771 120.388 84.0771C118.24 84.0771 116.498 85.819 116.498 87.9676C116.498 90.1163 118.24 91.8581 120.388 91.8581Z",
    fill: "#BE8871"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M125.194 87.9676C125.194 90.6214 123.042 92.7728 120.388 92.7728V93.7728C123.595 93.7728 126.194 91.1737 126.194 87.9676H125.194ZM120.388 83.1624C123.042 83.1624 125.194 85.3137 125.194 87.9676H126.194C126.194 84.7614 123.595 82.1624 120.388 82.1624V83.1624ZM115.583 87.9676C115.583 85.3137 117.735 83.1624 120.388 83.1624V82.1624C117.182 82.1624 114.583 84.7614 114.583 87.9676H115.583ZM120.388 92.7728C117.735 92.7728 115.583 90.6214 115.583 87.9676H114.583C114.583 91.1737 117.182 93.7728 120.388 93.7728V92.7728ZM123.779 87.9676C123.779 89.8401 122.261 91.3581 120.388 91.3581V92.3581C122.813 92.3581 124.779 90.3924 124.779 87.9676H123.779ZM120.388 84.5771C122.261 84.5771 123.779 86.0951 123.779 87.9676H124.779C124.779 85.5428 122.813 83.5771 120.388 83.5771V84.5771ZM116.998 87.9676C116.998 86.0951 118.516 84.5771 120.388 84.5771V83.5771C117.964 83.5771 115.998 85.5428 115.998 87.9676H116.998ZM120.388 91.3581C118.516 91.3581 116.998 89.8401 116.998 87.9676H115.998C115.998 90.3924 117.964 92.3581 120.388 92.3581V91.3581Z",
    fill: "#531D84",
    mask: "url(#path-13-outside-1_860_19028)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_860_19028)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120.388,
    cy: 83.0161,
    r: 2.47577,
    fill: "#768EE8"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.388,
    cy: 83.0161,
    r: 2.72577,
    stroke: "#531D84",
    strokeWidth: 0.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_860_19028)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.3242 40.5504L41.027 21.7693V19.1619L46.1078 21.7693L48.4333 33.1947L51.2391 21.7693H55.6374L58.4179 33.1947L60.7434 21.7693L65.8242 19.1619V21.7693L61.527 40.5504H56.6232L53.4382 29.0745L50.228 40.5504H45.3242Z",
    fill: "#8C5400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6572 40.7021C73.3259 40.7021 72.1548 40.5757 71.1437 40.3229C70.1494 40.0533 69.3153 39.5815 68.6412 38.9074C67.9671 38.2333 67.4616 37.2728 67.1246 36.0258C66.7875 34.7619 66.619 33.1357 66.619 31.1472C66.619 29.1587 66.7875 27.541 67.1246 26.294C67.4616 25.0301 67.9671 24.0611 68.6412 23.3871C69.3153 22.713 70.1494 22.2496 71.1437 21.9968C72.1548 21.7272 73.3259 21.5924 74.6572 21.5924C75.9885 21.5924 77.1512 21.7272 78.1455 21.9968C79.1566 22.2496 79.9992 22.713 80.6732 23.3871C81.3473 24.0611 81.8528 25.0301 82.1899 26.294C82.5269 27.541 82.6954 29.1587 82.6954 31.1472C82.6954 33.1357 82.5269 34.7619 82.1899 36.0258C81.8528 37.2728 81.3473 38.2333 80.6732 38.9074C79.9992 39.5815 79.1566 40.0533 78.1455 40.3229C77.1512 40.5757 75.9885 40.7021 74.6572 40.7021ZM74.6572 36.3038C75.4998 36.3038 76.1486 36.169 76.6036 35.8994C77.0586 35.6129 77.3703 35.0989 77.5388 34.3575C77.7074 33.616 77.7916 32.5459 77.7916 31.1472C77.7916 29.698 77.7074 28.6026 77.5388 27.8612C77.3703 27.1197 77.0586 26.6226 76.6036 26.3698C76.1486 26.117 75.4998 25.9906 74.6572 25.9906C73.8146 25.9906 73.1659 26.117 72.7109 26.3698C72.2559 26.6226 71.9441 27.1197 71.7756 27.8612C71.6071 28.6026 71.5228 29.698 71.5228 31.1472C71.5228 32.5459 71.6071 33.616 71.7756 34.3575C71.9441 35.0989 72.2559 35.6129 72.7109 35.8994C73.1659 36.169 73.8146 36.3038 74.6572 36.3038Z",
    fill: "#8C5400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9966 40.5504V37.9579L86.221 21.7693H90.8215L94.6889 34.9641L98.5564 21.7693H103.106L105.356 40.5504H100.629L99.4158 30.4142L96.9386 40.5504H92.3382L89.8862 30.6417L88.7235 40.5504H83.9966Z",
    fill: "#8C5400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.632 40.5504V21.7693H115.417C117.44 21.7693 118.889 22.2159 119.765 23.109C120.658 24.0022 121.105 25.2239 121.105 26.7742C121.105 27.8527 120.886 28.7375 120.448 29.4284C120.026 30.1193 119.386 30.5743 118.527 30.7934C119.42 31.0124 120.17 31.5011 120.776 32.2594C121.383 33.0178 121.686 34.0626 121.686 35.3938C121.686 37.2475 121.189 38.5704 120.195 39.3624C119.217 40.1544 117.751 40.5504 115.797 40.5504H107.632ZM112.536 29.1503H115.367C115.738 29.1503 116.007 29.0071 116.176 28.7206C116.361 28.4341 116.454 28.0802 116.454 27.659C116.454 27.086 116.336 26.6984 116.1 26.4962C115.881 26.2771 115.636 26.1676 115.367 26.1676H112.536V29.1503ZM112.536 36.1522H115.645C116.083 36.1522 116.42 36.0089 116.656 35.7224C116.909 35.4191 117.035 35.0147 117.035 34.5091C117.035 34.0036 116.909 33.6076 116.656 33.3211C116.42 33.0178 116.083 32.8661 115.645 32.8661H112.536V36.1522Z",
    fill: "#8C5400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.611 40.5504V37.9579L128.172 21.7693H134.289L139.85 37.9579V40.5504H134.769L134.011 37.5677H128.374L127.641 40.5504H122.611ZM129.512 33.1694H132.873L131.18 25.9401L129.512 33.1694Z",
    fill: "#8C5400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.858 40.5504V26.1676H139.132V21.7693H153.489V26.1676H148.762V40.5504H143.858Z",
    fill: "#8C5400"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3242 37.958L41.027 19.1769H46.1078L48.4333 30.6023L51.2391 19.1769H55.6374L58.4179 30.6023L60.7434 19.1769H65.8242L61.527 37.958H56.6232L53.4382 26.4821L50.228 37.958H45.3242Z",
    fill: "#FF9900"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6572 38.1097C73.3259 38.1097 72.1548 37.9833 71.1437 37.7305C70.1494 37.4609 69.3153 36.9891 68.6412 36.315C67.9671 35.6409 67.4616 34.6804 67.1246 33.4334C66.7875 32.1695 66.619 30.5433 66.619 28.5549C66.619 26.5664 66.7875 24.9486 67.1246 23.7016C67.4616 22.4377 67.9671 21.4688 68.6412 20.7947C69.3153 20.1206 70.1494 19.6572 71.1437 19.4044C72.1548 19.1348 73.3259 19 74.6572 19C75.9885 19 77.1512 19.1348 78.1455 19.4044C79.1566 19.6572 79.9992 20.1206 80.6732 20.7947C81.3473 21.4688 81.8528 22.4377 82.1899 23.7016C82.5269 24.9486 82.6954 26.5664 82.6954 28.5549C82.6954 30.5433 82.5269 32.1695 82.1899 33.4334C81.8528 34.6804 81.3473 35.6409 80.6732 36.315C79.9992 36.9891 79.1566 37.4609 78.1455 37.7305C77.1512 37.9833 75.9885 38.1097 74.6572 38.1097ZM74.6572 33.7114C75.4998 33.7114 76.1486 33.5766 76.6036 33.307C77.0586 33.0205 77.3703 32.5065 77.5388 31.7651C77.7074 31.0236 77.7916 29.9535 77.7916 28.5549C77.7916 27.1056 77.7074 26.0103 77.5388 25.2688C77.3703 24.5273 77.0586 24.0302 76.6036 23.7774C76.1486 23.5247 75.4998 23.3983 74.6572 23.3983C73.8146 23.3983 73.1659 23.5247 72.7109 23.7774C72.2559 24.0302 71.9441 24.5273 71.7756 25.2688C71.6071 26.0103 71.5228 27.1056 71.5228 28.5549C71.5228 29.9535 71.6071 31.0236 71.7756 31.7651C71.9441 32.5065 72.2559 33.0205 72.7109 33.307C73.1659 33.5766 73.8146 33.7114 74.6572 33.7114Z",
    fill: "#FF9900"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9966 37.958L86.221 19.1769H90.8215L94.6889 32.3717L98.5564 19.1769H103.106L105.356 37.958H100.629L99.4158 27.8218L96.9386 37.958H92.3382L89.8862 28.0493L88.7235 37.958H83.9966Z",
    fill: "#FF9900"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M107.632 37.958V19.1769H115.417C117.44 19.1769 118.889 19.6235 119.765 20.5166C120.658 21.4098 121.105 22.6315 121.105 24.1819C121.105 25.2604 120.886 26.1451 120.448 26.836C120.026 27.5269 119.386 27.9819 118.527 28.201C119.42 28.42 120.17 28.9087 120.776 29.6671C121.383 30.4254 121.686 31.4702 121.686 32.8015C121.686 34.6551 121.189 35.978 120.195 36.77C119.217 37.562 117.751 37.958 115.797 37.958H107.632ZM112.536 26.5579H115.367C115.738 26.5579 116.007 26.4147 116.176 26.1282C116.361 25.8417 116.454 25.4879 116.454 25.0666C116.454 24.4936 116.336 24.106 116.1 23.9038C115.881 23.6847 115.636 23.5752 115.367 23.5752H112.536V26.5579ZM112.536 33.5598H115.645C116.083 33.5598 116.42 33.4165 116.656 33.1301C116.909 32.8267 117.035 32.4223 117.035 31.9167C117.035 31.4112 116.909 31.0152 116.656 30.7287C116.42 30.4254 116.083 30.2737 115.645 30.2737H112.536V33.5598Z",
    fill: "#FF9900"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M122.611 37.958L128.172 19.1769H134.289L139.85 37.958H134.769L134.011 34.9753H128.374L127.641 37.958H122.611ZM129.512 30.577H132.873L131.18 23.3477L129.512 30.577Z",
    fill: "#FF9900"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M143.858 37.958V23.5752H139.132V19.1769H153.489V23.5752H148.762V37.958H143.858Z",
    fill: "#FF9900"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_860_19028",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 19,
    width: 113,
    height: 20
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3242 37.958L41.027 19.1769H46.1078L48.4333 30.6023L51.2391 19.1769H55.6374L58.4179 30.6023L60.7434 19.1769H65.8242L61.527 37.958H56.6232L53.4382 26.4821L50.228 37.958H45.3242Z",
    fill: "#FF9900"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6572 38.1097C73.3259 38.1097 72.1548 37.9833 71.1437 37.7305C70.1494 37.4609 69.3153 36.9891 68.6412 36.315C67.9671 35.6409 67.4616 34.6804 67.1246 33.4334C66.7875 32.1695 66.619 30.5433 66.619 28.5549C66.619 26.5664 66.7875 24.9486 67.1246 23.7016C67.4616 22.4377 67.9671 21.4688 68.6412 20.7947C69.3153 20.1206 70.1494 19.6572 71.1437 19.4044C72.1548 19.1348 73.3259 19 74.6572 19C75.9885 19 77.1512 19.1348 78.1455 19.4044C79.1566 19.6572 79.9992 20.1206 80.6732 20.7947C81.3473 21.4688 81.8528 22.4377 82.1899 23.7016C82.5269 24.9486 82.6954 26.5664 82.6954 28.5549C82.6954 30.5433 82.5269 32.1695 82.1899 33.4334C81.8528 34.6804 81.3473 35.6409 80.6732 36.315C79.9992 36.9891 79.1566 37.4609 78.1455 37.7305C77.1512 37.9833 75.9885 38.1097 74.6572 38.1097ZM74.6572 33.7114C75.4998 33.7114 76.1486 33.5766 76.6036 33.307C77.0586 33.0205 77.3703 32.5065 77.5388 31.7651C77.7074 31.0236 77.7916 29.9535 77.7916 28.5549C77.7916 27.1056 77.7074 26.0103 77.5388 25.2688C77.3703 24.5273 77.0586 24.0302 76.6036 23.7774C76.1486 23.5247 75.4998 23.3983 74.6572 23.3983C73.8146 23.3983 73.1659 23.5247 72.7109 23.7774C72.2559 24.0302 71.9441 24.5273 71.7756 25.2688C71.6071 26.0103 71.5228 27.1056 71.5228 28.5549C71.5228 29.9535 71.6071 31.0236 71.7756 31.7651C71.9441 32.5065 72.2559 33.0205 72.7109 33.307C73.1659 33.5766 73.8146 33.7114 74.6572 33.7114Z",
    fill: "#FF9900"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9966 37.958L86.221 19.1769H90.8215L94.6889 32.3717L98.5564 19.1769H103.106L105.356 37.958H100.629L99.4158 27.8218L96.9386 37.958H92.3382L89.8862 28.0493L88.7235 37.958H83.9966Z",
    fill: "#FF9900"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M107.632 37.958V19.1769H115.417C117.44 19.1769 118.889 19.6235 119.765 20.5166C120.658 21.4098 121.105 22.6315 121.105 24.1819C121.105 25.2604 120.886 26.1451 120.448 26.836C120.026 27.5269 119.386 27.9819 118.527 28.201C119.42 28.42 120.17 28.9087 120.776 29.6671C121.383 30.4254 121.686 31.4702 121.686 32.8015C121.686 34.6551 121.189 35.978 120.195 36.77C119.217 37.562 117.751 37.958 115.797 37.958H107.632ZM112.536 26.5579H115.367C115.738 26.5579 116.007 26.4147 116.176 26.1282C116.361 25.8417 116.454 25.4879 116.454 25.0666C116.454 24.4936 116.336 24.106 116.1 23.9038C115.881 23.6847 115.636 23.5752 115.367 23.5752H112.536V26.5579ZM112.536 33.5598H115.645C116.083 33.5598 116.42 33.4165 116.656 33.1301C116.909 32.8267 117.035 32.4223 117.035 31.9167C117.035 31.4112 116.909 31.0152 116.656 30.7287C116.42 30.4254 116.083 30.2737 115.645 30.2737H112.536V33.5598Z",
    fill: "#FF9900"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M122.611 37.958L128.172 19.1769H134.289L139.85 37.958H134.769L134.011 34.9753H128.374L127.641 37.958H122.611ZM129.512 30.577H132.873L131.18 23.3477L129.512 30.577Z",
    fill: "#FF9900"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M143.858 37.958V23.5752H139.132V19.1769H153.489V23.5752H148.762V37.958H143.858Z",
    fill: "#FF9900"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_860_19028)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.68,
    filter: "url(#filter5_f_860_19028)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 101.826,
    cy: 12.6809,
    r: 23.333,
    fill: "#FFD075"
  })))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5818 19.1619H86.2703L90.0746 19.594L92.1035 23.6988L90.5818 19.1619Z",
    fill: "#FFE0A5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6284 19.1619L94.6964 32.1246L99.1902 19.9893L103.122 19.1619H98.6284Z",
    fill: "#FFEBC3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M107.659 19.1619V37.9579H108.501V19.9911L116.085 19.1619H107.659Z",
    fill: "#FFE3AD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M128.075 19.1619L122.566 37.9579H123.538L128.723 20.1341L134.232 19.1619H128.075Z",
    fill: "#FFD075"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M139.094 19.1619V23.3748L140.066 20.1341L153.353 19.1619H139.094Z",
    fill: "#FFD075"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M133.608 113.278C136.603 113.278 137.511 111.888 137.373 111.198V30.8884H0L124.458 113.278H133.608Z",
    fill: "url(#paint45_linear_860_19028)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M68.7509 35.6228L125.694 86.9065V113.433L68.7509 97.517V35.6228Z",
    fill: "url(#paint46_linear_860_19028)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M134.409 79.9931C137.431 79.9931 137.512 78.6063 137.373 77.9129V19.249H92.8546L125.175 79.9931H134.409Z",
    fill: "url(#paint47_linear_860_19028)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M111.577 57.1103L111.993 57.5263V45.0447L111.161 46.7089V56.6942L111.577 57.1103Z",
    fill: "#FF9900"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M170 4C170 1.79086 171.791 0 174 0H207C209.209 0 211 1.79086 211 4V33C211 35.2091 209.209 37 207 37H170V4Z",
    fill: "#3E1263"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M175.562 9.8125H178.668C179.964 9.8125 180.842 10.1087 181.305 10.7012C181.773 11.2871 182.014 12.2799 182.027 13.6797V14.0508C182.027 15.0599 181.933 15.8542 181.744 16.4336C181.555 17.013 181.217 17.4329 180.729 17.6934C181.783 18.123 182.311 19.5 182.311 21.8242V22.1855C182.291 23.9043 182.031 25.138 181.529 25.8867C181.028 26.6289 180.159 27 178.922 27H175.562V9.8125ZM180.279 21.5312C180.279 20.4245 180.188 19.6497 180.006 19.207C179.824 18.7643 179.465 18.543 178.932 18.543H177.584V25.3691H178.824C179.397 25.3691 179.781 25.1445 179.977 24.6953C180.178 24.2461 180.279 23.39 180.279 22.127V21.5312ZM180.025 13.709C180.025 13.6895 180.025 13.6699 180.025 13.6504C180.025 12.5046 179.827 11.8275 179.43 11.6191C179.234 11.515 178.951 11.4629 178.58 11.4629H177.584V16.9902H178.727C179.117 16.9902 179.394 16.9284 179.557 16.8047C179.726 16.6745 179.846 16.4206 179.918 16.043C179.99 15.6654 180.025 15.0469 180.025 14.1875V13.709ZM184.703 9.8125H189.84V11.4922H186.725V17.3711H189.674V19.0508H186.725V25.3203H189.879V27H184.703V9.8125ZM191.109 9.8125H196.783V11.4922H195.016V27H193.004V11.4922H191.109V9.8125ZM200.318 9.8125H202.75L205.592 27H203.688L203.199 23.7188H200.084L199.635 27H197.711L200.318 9.8125ZM200.309 22.0781H202.945L201.588 12.9961H201.559L200.309 22.0781Z",
    fill: "#FFBB00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_860_19028",
    x: 0.490356,
    y: 43.125,
    width: 198.043,
    height: 81.8025,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_860_19028"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.6 0 0 0 0 0 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_860_19028",
    result: "effect2_innerShadow_860_19028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_860_19028",
    x: 0.490356,
    y: 86.8984,
    width: 165.59,
    height: 38.0291,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.635294 0 0 0 0 0.141176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_860_19028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_860_19028",
    x: 114.583,
    y: 82.1624,
    width: 11.6104,
    height: 11.6104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.705882 0 0 0 0 0.219608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_860_19028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_860_19028",
    x: 117.413,
    y: 80.0403,
    width: 5.95154,
    height: 5.95142,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.705882 0 0 0 0 0.219608 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_860_19028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_860_19028",
    x: 41.027,
    y: 17.1619,
    width: 112.462,
    height: 23.5403,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_860_19028"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_860_19028",
    x: 56.4926,
    y: -32.6521,
    width: 90.666,
    height: 90.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_860_19028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_860_19028",
    x1: 136.957,
    y1: 115.774,
    x2: 119.898,
    y2: 47.5411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC24C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF754E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF754E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF754E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF754E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF754E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF754E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF754E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_860_19028",
    x1: 99.5116,
    y1: 48.3732,
    x2: 99.5116,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187499,
    stopColor: "#3247B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#5C1FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_860_19028",
    x1: 99.5116,
    y1: 48.3732,
    x2: 99.5116,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187499,
    stopColor: "#3247B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#5C1FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_860_19028",
    x1: 99.5116,
    y1: 48.3732,
    x2: 99.5116,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187499,
    stopColor: "#3247B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#5C1FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_860_19028",
    x1: 99.5116,
    y1: 48.3732,
    x2: 99.5116,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187499,
    stopColor: "#3247B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#5C1FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_860_19028",
    x1: 99.5116,
    y1: 48.3732,
    x2: 99.5116,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187499,
    stopColor: "#3247B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#5C1FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_860_19028",
    x1: 99.5116,
    y1: 48.3732,
    x2: 99.5116,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187499,
    stopColor: "#3247B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#5C1FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_860_19028",
    x1: 99.5116,
    y1: 48.3732,
    x2: 99.5116,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0187499,
    stopColor: "#3247B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451042,
    stopColor: "#5C1FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B2D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_860_19028",
    x1: 113.657,
    y1: 81.2414,
    x2: 97.0153,
    y2: 80.8254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA110"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA110",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399295,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E63710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 79.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#8FC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#5B2678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977083,
    stopColor: "#365CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399295,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E63710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 79.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#8FC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#5B2678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977083,
    stopColor: "#365CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399295,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E63710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 79.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#8FC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#5B2678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977083,
    stopColor: "#365CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399295,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E63710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 79.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#8FC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#5B2678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977083,
    stopColor: "#365CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399295,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E63710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 79.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#8FC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#5B2678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977083,
    stopColor: "#365CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399295,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E63710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 79.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#8FC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#5B2678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977083,
    stopColor: "#365CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 121.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.399295,
    stopColor: "#667BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#E63710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_860_19028",
    x1: 99.5116,
    y1: 45.0447,
    x2: 99.5116,
    y2: 79.5773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A09EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466667,
    stopColor: "#8FC1FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#5B2678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977083,
    stopColor: "#365CE3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_860_19028",
    x1: 83.2854,
    y1: 88.3145,
    x2: 83.2854,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D11C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#780133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_860_19028",
    x1: 83.2854,
    y1: 88.3145,
    x2: 83.2854,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D11C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#780133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_860_19028",
    x1: 83.2854,
    y1: 88.3145,
    x2: 83.2854,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D11C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#780133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_860_19028",
    x1: 83.2854,
    y1: 88.3145,
    x2: 83.2854,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D11C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#780133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_860_19028",
    x1: 83.2854,
    y1: 88.3145,
    x2: 83.2854,
    y2: 124.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D11C3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#780133"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF254C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9004E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544792,
    stopColor: "#DA0202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF254C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9004E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544792,
    stopColor: "#DA0202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF254C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9004E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544792,
    stopColor: "#DA0202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF254C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9004E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544792,
    stopColor: "#DA0202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF254C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9004E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_860_19028",
    x1: 83.2854,
    y1: 85.8181,
    x2: 83.2854,
    y2: 122.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.513542,
    stopColor: "#FFE5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544792,
    stopColor: "#DA0202"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_860_19028",
    x1: 134.024,
    y1: 113.692,
    x2: 103.907,
    y2: 37.4264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB032",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_860_19028",
    x1: 137.011,
    y1: 104.237,
    x2: 83.9591,
    y2: 97.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC24C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_860_19028",
    x1: 134.829,
    y1: 80.4092,
    x2: 115.412,
    y2: 21.2271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB032"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB032",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDungeonMaster);
export default __webpack_public_path__ + "static/media/dungeon_master.8b2f1f8a1a81ad9d80b567b151bdfd24.svg";
export { ForwardRef as ReactComponent };